export default {
    title: 'Gesprächstermin erstellen',
    createYearInterview: 'Gesprächstermin erstellen',
    createAndEditYearInterview: 'Erstellen und weiter bearbeiten',
    createYearInterviewSuccess: 'Der Gesprächstermin wurde erfolgreich erstellt.',
    createYearInterviewError: 'Der Gesprächstermin konnte nicht erstellt werden.'
}